const Local = ({ src, width, quality }) => {
  return `${src}?quality=${quality || 75}`;
};
export default Local;
